import {
  CircularProgress,
  Container,
  Grid,
  Stack,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { get_service_by_id } from "../../services/services";
import Navbar from "../../component/navbar/Navbar";
import Footer from "../Footer/Footer";
import { asyncStatus } from "../../utils/asyncStatus";
import { themeOrange } from "../../utils/colorTheme";
import { getServiceLocalImage } from "../../utils/serviceImages";
import {
  SERVICE_DETAIL_PAGE_CONSTANT,
  steps_constants,
} from "../../store/constants";
import FirstCard from "../../component/ServiceDetailCards/FirstCard";
import SecondCard from "../../component/ServiceDetailCards/SecondCard";
import DiscountCard from "../../component/ServiceDetailCards/DiscountCard";
import FirstStep from "../../component/StepScreen/FirstStep";
import SecondStep from "../../component/StepScreen/SecondStep";
import WrappedLastStep from "../../component/StepScreen/LastStep";

const ServiceDetailsPage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [jobsState, setJobsState] = useState(null);
  const [serviceId, setServiceId] = useState("");

  const {
    get_service_by_id_status,
    get_service_by_id_data,
  } = useSelector((state) => state.serviceManage);
  const { job_step } = useSelector((state) => state.uiControle);

  const loader = get_service_by_id_status === asyncStatus.LOADING;

  useEffect(() => {
    const service_id = localStorage.getItem(SERVICE_DETAIL_PAGE_CONSTANT?.service_id);
    setServiceId(service_id);
    const jobs_steps = localStorage.getItem(steps_constants.JOBS_STEP);
    setJobsState(jobs_steps);
  }, []);

  useEffect(() => {
    dispatch(get_service_by_id(serviceId || id));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const jobs_steps = localStorage.getItem(steps_constants.JOBS_STEP);
    setJobsState(jobs_steps);
  }, [job_step]);

  const renderMainContent = () => {
    if (jobsState === null) return <FirstCard />;
    switch (jobsState) {
      case "3": return <WrappedLastStep />;
      case "1": return <FirstStep />;
      case "2":
      default: return <SecondStep />;
    }
  };

  if (loader) {
    return (
      <div>
        <Navbar />
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ height: "100vh" }}
        >
          <CircularProgress size={30} sx={{ color: themeOrange }} />
        </Stack>
      </div>
    );
  }

  return (
    <Box sx={{ backgroundColor: "#fafafa", minHeight: "100vh" }}>
      <Navbar />

      {/* Hero Section with Background Image */}
      <Box
        sx={{
          position: "relative",
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          height: { xs: "300px", sm: "380px", md: "450px", lg: "500px" },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${getServiceLocalImage(get_service_by_id_data?.service?.name)})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </Box>

      <Container maxWidth="xl" sx={{ py: { xs: 3, md: 5 }, mt: { xs: -6, md: -10 }, position: "relative", zIndex: 1, px: { xs: 3, sm: 5, md: 8, lg: 12 } }}>
        <Grid container spacing={4}>
          {/* Main Content - full width */}
          <Grid item xs={12}>
            <Box
              sx={{
                backgroundColor: "white",
                borderRadius: "10px",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                overflow: "hidden",
              }}
            >
              {renderMainContent()}
            </Box>
          </Grid>

          {/* Booking widget (prices + address) at the bottom — desktop only,
              mobile shows it inside the main content flow */}
          {jobsState !== null && jobsState !== "3" && (
            <Grid item xs={12} sx={{ display: { xs: "none", lg: "block" } }}>
              <SecondCard />
            </Grid>
          )}
        </Grid>
      </Container>

      <Footer />
    </Box>
  );
};

export default ServiceDetailsPage;
